export const StatusOptions = [
    { label: 'Live', value: 'L',id:1,selected:false },
    { label: 'TBS', value: 'TBS',id:2,selected:false },
    { label: 'Streamed', value: 'S',id:3,selected:false },
  ];